import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const DetailContainer = styled.div<{ marginBottom?: number }>`
    display: flex;
    flex-direction: column;
    padding: 0;
    margin-bottom: ${(props) => props.marginBottom ? `${props.marginBottom}px` : '24px'};
    padding: 0 32px;
    max-width: 100%;

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 0 24px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 0;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0 16px;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
`;

export const CharContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
`;

export const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
`;

export const DetailLabel = styled.span`
    ${FONTS.H4};
    color: ${COLORS.TextPrimary};
    margin-bottom: 8px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
    }
`;

export const DetailInfo = styled.span<{ showAllLines?: boolean, linesNumber?: number, maxWidth?: boolean }>`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    display: -webkit-box;
    -webkit-line-clamp: ${(props) => props.showAllLines ? 'inherit' : (props.linesNumber || 6)};
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    position: relative;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }

    ${props => props.maxWidth && css`
        -webkit-line-clamp: 1;
        max-width: 45%;
        padding-right: 5px;
    `}
`;

export const DetailInfoHover = styled.span`
    position: absolute;
    right: 0;
    top: 0;
    background-color: ${COLORS.BgSurface};
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    z-index: 1;
    width: fit-content;
    cursor: pointer;
    padding: 0 5px;
    border-radius: 5px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const DotsComponent = styled.div`
    flex-grow: 1;
    border-bottom: 0.5px dashed ${COLORS.TextSecondary};
    height: 80%;
    margin: 0 2px;
`;

export const ShowLessButton = styled.span`
    ${FONTS.S};
    color: ${COLORS.Link};
    cursor: pointer;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const RowIconsContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 28px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 16px;
    }

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const IconInfoText = styled.span`
    height: 100%;
    display: flex;
    align-items: center;
    ${FONTS.S};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const Icon = styled.div<{ imgUrl: string }>`
    width: 24px;
    height: 24px;
    background-image: url('${(props) => props.imgUrl}');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-right: 8px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 20px;
        height: 20px;
    }
`;
